import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

/**
 * Get tracking records with filters
 * @param {Object} params - Filter parameters
 * @param {string} [params.store_id] - Filter by store ID
 * @param {boolean} [params.synced] - Filter by sync status
 * @param {string} [params.date_from] - Filter from date (ISO 8601)
 * @param {string} [params.date_to] - Filter to date (ISO 8601)
 * @param {number} [params.limit=100] - Maximum records to return
 * @param {number} [params.skip=0] - Records to skip (pagination)
 * @returns {Promise<Object>} Tracking records response
 */
export const getTrackingRecords = async ({
  store_id,
  synced,
  date_from,
  date_to,
  limit = 100,
  skip = 0
}) => {
  const params = new URLSearchParams();
  
  if (store_id) params.append('store_id', store_id);
  if (synced !== undefined) params.append('synced', synced);
  if (date_from) params.append('date_from', date_from);
  if (date_to) params.append('date_to', date_to);
  if (limit) params.append('limit', limit);
  if (skip) params.append('skip', skip);

  const res = await axios.get(
    `${API_URL}/tracking?${params.toString()}`,
    header()
  );
  return res.data;
};

/**
 * Get tracking records by store
 * @param {string} storeId - Store ID
 * @param {Object} [filters] - Optional filters
 * @param {boolean} [filters.synced] - Filter by sync status
 * @param {string} [filters.date] - Filter by specific date
 * @param {string} [filters.startDate] - Filter from date
 * @param {string} [filters.endDate] - Filter to date
 * @returns {Promise<Object>} Tracking records response
 */
export const getTrackingByStore = async (storeId, filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.synced !== undefined) params.append('synced', filters.synced);
  if (filters.date) params.append('date', filters.date);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);

  const queryString = params.toString();
  const url = `${API_URL}/tracking/by-store/${storeId}${queryString ? `?${queryString}` : ''}`;

  const res = await axios.get(url, header());
  return res.data;
};

export default {
  getTrackingRecords,
  getTrackingByStore,
};
